export const LOAD_CONTENT_REQUEST = 'load_content_request'
export const LOAD_CONTENT_RESPONSE = 'load_content_response'
export const SUBMIT_CONTACT_INFO_REQUEST = 'submit_contact_info_request'
export const SUBMIT_CONTACT_INFO_RESPONSE = 'submit_contact_info_response'

export const CMS_ERROR = 'cms_error'
